class Debounce {
  constructor() {
    this.timeout = "";
  }

  makeRequest(request, debounce) {
    if (debounce) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      this.timeout = setTimeout(() => {
        request();
      }, 500);
    } else {
      request();
    }
  }
}

export const debounce = new Debounce();
